export default "__VITE_ASSET__f5qg1CVL__"